var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import EditableTemplate from '../templates/editable';
import EventEmitter from '../modules/event-emitter';
var Defaults = {
    title: false,
    value: null,
    showbuttons: true,
    type: 'default',
    mode: 'inline'
};
var AbstractEditable = /** @class */ (function () {
    function AbstractEditable(args) {
        this._template = new EditableTemplate();
        this._element = null;
        this._args = this._getArgs(args);
        this._isInit = false;
        this._isDisabled = false;
        this.Events = new EventEmitter();
        new GlobalEvents();
    }
    /**
     * @returns {AbstractEditable}
     */
    AbstractEditable.prototype.close = function () {
        this.removeElement();
        Window.ACEditable = null;
        this.Events.emit('close', this);
        return this;
    };
    AbstractEditable.prototype.get = function () {
        this._element = this.createElement();
        this.beforeRender();
        this.render();
        this.valueToInput(this._args.value);
        this.initEvents();
        return this._element;
    };
    AbstractEditable.prototype.getEditableTemplate = function () {
        return this._template;
    };
    AbstractEditable.prototype.disable = function () {
        this._element.querySelectorAll('input, select, textarea, button').forEach(function (input) {
            input.disabled = true;
        });
        this._isDisabled = true;
        return this;
    };
    AbstractEditable.prototype.enable = function () {
        this._element.querySelectorAll('input, select, textarea, button').forEach(function (input) {
            input.disabled = false;
        });
        this._isDisabled = false;
        return this;
    };
    AbstractEditable.prototype.beforeRender = function () {
        this._template.setTemplate(this.getTemplate());
        this._template.addClass('-' + this._args.type);
        this._template.setError('');
        if (!this._args.hasOwnProperty('showbuttons') && !this._args.showbuttons) {
            this._template.showButtons(false);
        }
    };
    AbstractEditable.prototype.save = function () {
        if (this._isDisabled) {
            return;
        }
        var value = this.getValue();
        if (!this.validate(value)) {
            return;
        }
        this.Events.emit('save', this);
    };
    AbstractEditable.prototype.initEvents = function () {
        var _this = this;
        if (this._isInit) {
            return;
        }
        this.getElement().addEventListener('click', function (e) {
            if (_this.preventStopPropagation(e)) {
                return;
            }
            e.stopPropagation();
        });
        this.getElement().querySelector('button[data-submit]').addEventListener('click', function (e) {
            e.preventDefault();
            _this.save();
        });
        this.getElement().querySelector('button[data-cancel]').addEventListener('click', function (e) {
            e.preventDefault();
            _this.close();
        });
        this.getElement().querySelector('form').addEventListener('submit', function (e) {
            e.preventDefault();
            _this.save();
        });
        this._isInit = true;
    };
    AbstractEditable.prototype.preventStopPropagation = function (e, type) {
        return false;
    };
    AbstractEditable.prototype.removeElement = function () {
        if (this._element) {
            this._element.remove();
        }
    };
    AbstractEditable.prototype.toggleLoading = function (loading) {
        if (loading === void 0) { loading = true; }
        if (!this.getElement()) {
            return;
        }
        if (loading) {
            this.getElement().classList.add('-loading');
        }
        else {
            this.getElement().classList.remove('-loading');
        }
    };
    AbstractEditable.prototype.createElement = function () {
        return this._template.el;
    };
    AbstractEditable.prototype.setValue = function (value) {
        this._args.value = value;
        return this;
    };
    AbstractEditable.prototype.setObjectId = function (objectId) {
        this._args.object_id = objectId;
        return this;
    };
    AbstractEditable.prototype.getObjectId = function () {
        return this._args.hasOwnProperty('object_id') ? this._args.object_id : false;
    };
    AbstractEditable.prototype.setError = function (error) {
        this._template.setError(error);
    };
    AbstractEditable.prototype.getElement = function () {
        return this._element;
    };
    AbstractEditable.prototype.getValue = function () { };
    AbstractEditable.prototype.getTemplate = function () { };
    AbstractEditable.prototype.render = function () { };
    AbstractEditable.prototype.valueToInput = function (value) { };
    AbstractEditable.prototype.validate = function () {
        if (AbstractEditable.hasFormValidation()) {
            var form = this.getElement().querySelector('form');
            if (!this.getElement().querySelector('form').checkValidity()) {
                form.reportValidity();
                return false;
            }
        }
        return true;
    };
    // Private
    AbstractEditable.prototype._getArgs = function (args) {
        this._defaults = __assign({}, Defaults);
        this._setDefaults();
        return Object.assign({}, this._defaults, args);
    };
    AbstractEditable.prototype._setDefaults = function () { };
    AbstractEditable.prototype._handleOutsideClickEvent = function () {
        this.close();
    };
    // Static
    AbstractEditable.hasFormValidation = function () {
        return (typeof document.createElement('input').checkValidity === 'function');
    };
    ;
    return AbstractEditable;
}());
export default AbstractEditable;
var GlobalEvents = /** @class */ (function () {
    function GlobalEvents() {
        if (AdminColumns.Editing.Editables.loaded) {
            return;
        }
        this._setEscapeEvent();
        AdminColumns.Editing.Editables.loaded = true;
    }
    GlobalEvents.prototype._setEscapeEvent = function () {
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' || e.key === 'Esc') {
                if (Window.ACEditable) {
                    Window.ACEditable.close();
                }
            }
        }, true);
    };
    GlobalEvents.prototype._setClickEvent = function () {
        document.addEventListener('click', function (e) {
            if (e.target === document.body) {
                return;
            }
            if (e.target.classList.contains('select2-results__option')) {
                return;
            }
            if (Window.ACEditable) {
                Window.ACEditable.close();
            }
        });
    };
    return GlobalEvents;
}());
